module.exports = __webpack_public_path__ + "static/media/red-circle.0bf3f031.svg";